// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements is found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: process.env.API_URL || "https://juchating-dev-api.kncuration.net", // 개발 환경 API URL
  apiTimeout: parseInt(process.env.API_TIMEOUT || "30000"), // API 요청 타임아웃 (30초)
  // API 인증 관련 설정
  auth: {
    tokenKey: process.env.AUTH_TOKEN_KEY || "auth_token",
    refreshTokenKey: process.env.AUTH_REFRESH_TOKEN_KEY || "refresh_token",
    tokenExpiryKey: process.env.AUTH_TOKEN_EXPIRY_KEY || "token_expiry",
  },
  // 임시 storageBucket 설정 (기존 코드 호환성을 위해)
  storageBucket: process.env.STORAGE_BUCKET || "juchating-dev-api.kncuration.net",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
